const profileData = {
  name: "Mohammad Cordova",
  title: "System Developer",
  education: "Bachelor of Science in Computer Engineering (BSCpE)",
  bio: "I am a Bachelor of Science in Computer Engineering (BSCpE) graduate and a System Developer with experience in designing, developing, and maintaining information systems. I have worked on logistics systems, inventory management, expense tracking applications, and IT infrastructure support.",
  contact: {
    email: "your.email@example.com",
    github: "https://github.com/yourusername",
    linkedin: "https://linkedin.com/in/yourprofile"
  },
  accomplishments: [
    "Developed and maintained multiple production-level systems",
    "Implemented real-time data tracking using Firebase",
    "Designed database schemas and ERDs for enterprise systems",
    "Provided IT support and system improvements for organizational operations"
  ]
};

export default profileData;
